import { pageBreadcrumbStyles } from "@insite/content-library/Components/PageBreadcrumbs";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

pageBreadcrumbStyles.breadcrumbs = {
    css: css`
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    flex-wrap: wrap;
                `,
                null,
                null,
                null,
                null,
            ]);
        }},
    `,
};
